import { IconSearch, IconX } from "@tabler/icons-react";
import { Trans, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import { Button } from "../common/Button";
import { cx } from "../common/cx";
import styles from "./ContractFilters.module.css";

export interface ContractFiltersProps {
  clientOptions: ReadonlyArray<{ id: string; name: string }>;
  difficultyOptions: readonly number[];
  clientId: string | "all";
  difficulty: number | "all";
  search: string;
  availableOnly: boolean;
  count: number;
  onClient: (id: string | "all") => void;
  onDifficulty: (d: number | "all") => void;
  onSearch: (s: string) => void;
  onAvailableOnly: (v: boolean) => void;
  onReset: () => void;
}

export function ContractFilters({
  clientOptions,
  difficultyOptions,
  clientId,
  difficulty,
  search,
  availableOnly,
  count,
  onClient,
  onDifficulty,
  onSearch,
  onAvailableOnly,
  onReset,
}: ContractFiltersProps): JSX.Element {
  const { i18n } = useLingui();
  const dirty =
    clientId !== "all" || difficulty !== "all" || search.trim() !== "" || availableOnly;

  return (
    <div className={styles.panel}>
      <div className={styles.row}>
        <label className={styles.search}>
          <IconSearch size={16} aria-hidden="true" />
          <input
            type="search"
            value={search}
            placeholder={i18n._(msg`Поиск по названию`)}
            aria-label={i18n._(msg`Поиск по названию`)}
            onChange={(e) => onSearch(e.target.value)}
          />
        </label>

        <select
          className={styles.select}
          value={clientId}
          aria-label={i18n._(msg`Клиент`)}
          onChange={(e) => onClient(e.target.value)}
        >
          <option value="all">{i18n._(msg`Все клиенты`)}</option>
          {clientOptions.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.row}>
        <div className={styles.chips}>
          <span className={styles.chipsLabel}>
            <Trans>Сложность</Trans>
          </span>
          <button
            type="button"
            className={cx(styles.chip, difficulty === "all" && styles.chipActive)}
            aria-pressed={difficulty === "all"}
            onClick={() => onDifficulty("all")}
          >
            <Trans>Все</Trans>
          </button>
          {difficultyOptions.map((d) => (
            <button
              key={d}
              type="button"
              className={cx(styles.chip, difficulty === d && styles.chipActive)}
              aria-pressed={difficulty === d}
              onClick={() => onDifficulty(d)}
            >
              {d}
            </button>
          ))}
        </div>

        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={availableOnly}
            onChange={(e) => onAvailableOnly(e.target.checked)}
          />
          <Trans>Только доступные</Trans>
        </label>
      </div>

      <div className={styles.foot}>
        <span className={styles.count}>
          <Trans>Найдено: {count}</Trans>
        </span>
        {dirty && (
          <Button variant="ghost" size="small" icon={<IconX size={14} />} onClick={onReset}>
            <Trans>Сбросить</Trans>
          </Button>
        )}
      </div>
    </div>
  );
}
